import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Row, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Button, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { applyVoucherRequest, applyVoucher, checkVoucherConditionsFromStore } from '../../VoucherActions';
import { getCartVoucher } from '../../../Cart/CartActions';

import VoucherLineView from '../view/VoucherLineView';

class VoucherApplyForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            code: '',
            isLoading: false,
            displayError: false,
        };
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value,
        });
    }

    handleSubmit = event => {
        event && event.preventDefault();
        if(this.state.code) {
            this.setState({
                isLoading: true,
            });
            this.props.dispatch(applyVoucherRequest(this.state.code.toUpperCase())).then(voucher => {
                this.setState({
                    isLoading: false,
                });
                if(voucher) {
                    this.props.dispatch(applyVoucher(voucher));
                } else {
                    this.setState({
                        displayError: true,
                    });
                }
            });
        }
    }

    handleRemoveVoucher = event => {
        event && event.preventDefault();
        this.props.dispatch(applyVoucher({}));
    }

    render() {
        return (
            <Row>
                <Col xs="12" md="6" className="text-right">
                    <span className="text-dark special-font">
                        <strong><FormattedMessage id="cartVoucherApplyTitle" defaultMessage="Voucher code" /></strong><br />
                    </span>
                </Col>
                <Col>
                    {
                        !this.props.voucher || (!this.props.voucher.code && !this.props.voucher.isAuto)
                            ? (
                                <Fragment>
                                    <InputGroup>
                                        <Input type="text" name="code" value={this.state.code} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'voucherCodePlaceholder', defaultMessage: 'Type your voucher code' })} />
                                        {this.state.code ? <InputGroupAddon addonType="append"><Button color="success" onClick={this.handleSubmit}>{this.state.isLoading ? <FontAwesome name="spinner" spin /> : <FontAwesome name="check" />}</Button></InputGroupAddon> : null}
                                    </InputGroup>
                                    {
                                        this.state.displayError && (
                                            <strong className="text-danger"><FormattedMessage id="voucherNotExistsError" defaultMessage="This coupon does not exist!" /></strong>
                                        )
                                    }
                                </Fragment>
                            )
                            : (
                                <div className="text-right">
                                    <strong className="text-dark"><VoucherLineView voucher={this.props.voucher} /></strong><br />
                                    {!this.props.isVoucherValid && (
                                        <strong className="d-block text-danger"><FormattedMessage id="voucherNotValidError" defaultMessage="This coupon could not be applied to your order!" /></strong>
                                    )}
                                    <a href="#" className="text-uppercase text-underline" onClick={this.handleRemoveVoucher}><FormattedMessage id="switch" defaultMessage="Switch" /></a>
                                </div>
                            )
                    }
                </Col>
            </Row>
        );
    }
}

function mapStateToProps(store, props) {
    const voucher = getCartVoucher(store);
    return {
        voucher,
        isVoucherValid: checkVoucherConditionsFromStore(store, voucher),
    };
}

VoucherApplyForm.defaultProps = {
    voucher: null,
    isVoucherValid: false,
};

VoucherApplyForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    voucher: PropTypes.object,
    isVoucherValid: PropTypes.bool,
};

export default connect(mapStateToProps)(injectIntl(VoucherApplyForm));
